import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import { isSome as e } from "../core/maybe.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as r } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as i } from "../core/accessorSupport/decorators/reader.js";
import { subclass as s } from "../core/accessorSupport/decorators/subclass.js";
import p from "./Symbol3DLayer.js";
import a from "./support/Symbol3DMaterial.js";
import { lineJoins as l, pathCaps as h } from "./support/symbolLayerUtils3D.js";

var _n;

var d = _n = /*#__PURE__*/function (_p) {
  _inherits(n, _p);

  var _super = _createSuper(n);

  function n(t) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, t), _this.material = null, _this.castShadows = !0, _this.type = "path", _this.profile = "circle", _this.join = "miter", _this.cap = "butt", _this.width = void 0, _this.height = void 0, _this.anchor = "center", _this.profileRotation = "all";
    return _this;
  }

  _createClass(n, [{
    key: "readWidth",
    value: function readWidth(t, e) {
      return null != t ? t : null == e.height && null != e.size ? e.size : void 0;
    }
  }, {
    key: "readHeight",
    value: function readHeight(t, e) {
      return null != t ? t : null == e.width && null != e.size ? e.size : void 0;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _n({
        enabled: this.enabled,
        material: e(this.material) ? this.material.clone() : null,
        castShadows: this.castShadows,
        profile: this.profile,
        join: this.join,
        cap: this.cap,
        width: this.width,
        height: this.height,
        profileRotation: this.profileRotation,
        anchor: this.anchor
      });
    }
  }]);

  return n;
}(p);

t([o({
  type: a,
  json: {
    write: !0
  }
})], d.prototype, "material", void 0), t([o({
  type: Boolean,
  nonNullable: !0,
  json: {
    write: !0,
    default: !0
  }
})], d.prototype, "castShadows", void 0), t([r({
  Path: "path"
}, {
  readOnly: !0
})], d.prototype, "type", void 0), t([o({
  type: ["circle", "quad"],
  json: {
    write: !0,
    default: "circle"
  }
})], d.prototype, "profile", void 0), t([o({
  type: l,
  json: {
    write: !0,
    default: "miter"
  }
})], d.prototype, "join", void 0), t([o({
  type: h,
  json: {
    write: !0,
    default: "butt"
  }
})], d.prototype, "cap", void 0), t([o({
  type: Number,
  json: {
    write: {
      enabled: !0,
      target: {
        width: {
          type: Number
        },
        size: {
          type: Number
        }
      }
    }
  }
})], d.prototype, "width", void 0), t([i("width", ["width", "size", "height"])], d.prototype, "readWidth", null), t([o({
  type: Number,
  json: {
    write: !0
  }
})], d.prototype, "height", void 0), t([i("height", ["height", "size", "width"])], d.prototype, "readHeight", null), t([o({
  type: ["center", "bottom", "top"],
  json: {
    write: !0,
    default: "center"
  }
})], d.prototype, "anchor", void 0), t([o({
  type: ["heading", "all"],
  json: {
    write: !0,
    default: "all"
  }
})], d.prototype, "profileRotation", void 0), d = _n = t([s("esri.symbols.PathSymbol3DLayer")], d);
var c = d;
export { c as default };